import React from "react";
import styled from "styled-components";
import { generateUUID } from "../../../../common/utils/uuid";
import { injectIntl, WrappedComponentProps } from "react-intl";
import {
  withBrand,
  GenericBrandProviderProps,
} from "../../../../common/providers/brand/brand-context";
import { matchPath } from "react-router-dom";

const Styled = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    background-color: white;

    & > iframe {
      display: block;
    }
  `,
};

interface PageViewerProps {
  vbid: string;
  createPageViewer: (opts) => void;
  location?: string;
}

class MosaicPageViewer extends React.Component<
  PageViewerProps & WrappedComponentProps & GenericBrandProviderProps
> {
  private readonly containerId = generateUUID();

  componentDidMount() {
    const match = matchPath<{ type: string; detail: string }>(
      `/${this.props.location}`,
      {
        path: "/:type/:detail*",
      }
    );
    const isSnippet = match?.params.type === "cfirange";
    this.props.createPageViewer({
      contentId: this.props.vbid,
      elementId: this.containerId,
      url:
        !isSnippet && this.props.location
          ? `/books/${this.props.vbid}/${this.props.location}`
          : undefined,
      range: isSnippet ? `/${match?.params.detail}` : undefined,
      featureSettings: {
        Highlights: { enabled: this.props.brand.getProp("Highlights.enabled") },
        ImageTools: {
          zoom: {
            enabled: this.props.brand.getProp("PageImageZoom.enabled"),
            label: this.props.intl.formatMessage({
              id: "imageZoom.viewImage",
            }),
          },
          flashcards: {
            enabled: false, // Enabled/disabled dynamically
            label: this.props.intl.formatMessage({
              id: "imageFlashcards.addToFlashcard",
            }),
          },
        },
      },
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return <Styled.Container id={this.containerId} role="main" />;
  }
}

export default withBrand(injectIntl(MosaicPageViewer));
